import React from 'react';
import { Box, Divider, Stack, Typography, useMediaQuery } from '@mui/material';

// COMPONENTS
import HelpTooltip from '../../components/common/HelpTooltip';

// ICONS
import CreditsIcon from '../../components/icons/CreditsIcon';
import MessagesIcon from '../../components/icons/MessagesIcon';

// MESSAGES
import ComposeFormattedMessages from '../../messages/websms/ComposeFormattedMessages';

// THEME
import theme from '../../styles/theme';

export default function CreditsMessagesCounts({
  creditsTotal,
  messagesTotal,
  sx,
}) {
  const lgAndUp = useMediaQuery(theme.breakpoints.up('lg'));

  // Credit and message data
  const data = [
    {
      id: 'credits',
      title: ComposeFormattedMessages.creditsRemaining,
      total: creditsTotal,
      message:
        'Credit is the cost of a message. The destination (country) and the length of the message both impact the credit cost of a message.',
      icon: (
        <CreditsIcon sx={{ height: 40, width: 40, color: 'primary.main' }} />
      ),
    },
    {
      id: 'messages',
      title: ComposeFormattedMessages.messageRemaining,
      total: messagesTotal,
      message:
        'A message is any one SMS sent to any phone number. The length of the message does not matter.',
      icon: (
        <MessagesIcon sx={{ height: 35, width: 35, color: 'primary.main' }} />
      ),
    },
  ];

  return (
    <Stack
      sx={{
        flexDirection: { xs: 'row', lg: 'column' },
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      {data.map((item) => {
        return (
          <React.Fragment key={item.id}>
            <Stack
              sx={{
                paddingX: { xs: 4, lg: 1 },
                paddingY: { xs: 0, lg: 4 },
                flexDirection: 'row',
              }}
            >
              <Stack
                sx={{
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  paddingRight: 1,
                }}
              >
                {item.icon}
              </Stack>

              <Box>
                <Typography sx={{ fontSize: 27 }}>{item.total}</Typography>
                <Stack sx={{ flexDirection: 'row' }}>
                  <Typography>{item.title}</Typography>

                  <HelpTooltip
                    message={<Typography>{item.message}</Typography>}
                  />
                </Stack>
              </Box>
            </Stack>

            <Divider
              orientation={lgAndUp ? 'horizontal' : 'vertical'}
              flexItem
              sx={{
                borderRightWidth: { xs: 1.5, lg: 0 },
                borderTopWidth: { xs: 0, lg: 1.5 },
                '&:nth-last-of-type(1)': {
                  display: 'none',
                },
              }}
            />
          </React.Fragment>
        );
      })}
    </Stack>
  );
}
